import React from 'react';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

import { Provider } from 'react-redux';
import { createStore } from 'redux';
import reducer from './store/reducer';
import { createRoot } from "react-dom/client";

const store = createStore( reducer );

const container = document.getElementById( 'bf-instant-quote' );
const root = createRoot( container )


root.render(
    <Provider store={ store }>
        <App mode={ container.getAttribute( 'data-mode' ) }/>
    </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
